<template>
  <section class="brief" :id="blockId || undefined">
    <div class="container">
      <ink-slab>
        <section-title
          align="left"
          tone="dark"
          data-aos="fade-up"
          :kicker="kicker"
          :title="title"
          :lede="lede"
        />

        <panel-list
          tone="dark"
          bare
          :columns="2"
          icon="check"
          mark-size="sm"
          mark-variant="outline"
          :items="items"
        />
      </ink-slab>
    </div>
  </section>
</template>

<style lang="scss" scoped>
/* No rules of its own. The slab is InkSlab, shared with the brand-order slip and
   the portfolio case brief, and the ruled list inside it is PanelList's bare
   variant, because the slab already owns the surface and the glow; the list only
   divides it. */
</style>

<script>
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { library as FontAwesomeLibrary } from '@fortawesome/fontawesome-svg-core';
import InkSlab from '@/Components/InkSlab.vue';
import PanelList from '@/Components/PanelList.vue';
import SectionTitle from '@/Components/SectionTitle.vue';

FontAwesomeLibrary.add(faCheck);

export default {
  components: {
    InkSlab,
    PanelList,
    SectionTitle
  },

  props: {
    kicker: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: true
    },
    lede: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      required: true
    },
    blockId: {
      type: String,
      default: ''
    }
  }
};
</script>
